module.exports = __webpack_public_path__ + "static/linkedin-ads-7efad93fcc47f3f8a582ec89d490a3ac.png";